define([
        'jquery',
        "../tabs/shared-toolbar-model"
    ],
    function ($, Shared) {

        'use strict';

        return $.extend(true, {}, Shared,{show : {

            selector : {
                id : "input",
                type : "checkbox",
                source : [
                    { value : "code", label : "Code"}
                ]
            },

            template : {
                title : "Show"
            }
        }})

    });


//////////////////
// WEBPACK FOOTER
// ./src/config/tabs/chart-toolbar-model.js
// module id = 66
// module chunks = 0